<template>
  <div id="start">
    <h1 class="text-center">
      <img src="img/dreamhome.svg" alt="極めろ！ネットセキュリティ 夢のマイホーム" class="img-fluid" />
    </h1>

    <div class="row justify-content-center w-100">
      <div class="col-12 col-sm-10 col-md-9 mb-3">
        <picture>
          <source media="(min-width: 768px)" srcset="img/start_main.svg" class="img-fluid" />
          <img src="img/start_main_sp.svg" alt class="img-fluid" />
        </picture>
      </div>
    </div>
    <b-button @click="$emit('set')" class="btn-click pulse-button my-md-3">
      建設
      <small>（診断）</small>
      <br class="d-md-none" />スタート
      <font-awesome-icon icon="arrow-circle-right" />
    </b-button>
    <!-- <div class="text-center mt-4">
      <a class="d-block" href="../quiz-cp/">
        <picture>
          <source media="(min-width: 576px)" srcset="img/bnr-campaign.png" class="img-fluid" />
          <img src="img/bnr-campaign-sp.png" alt class="img-fluid" />
        </picture>
      </a>
    </div>-->
  </div>
</template>


<script>
export default {
  name: "quiz-start"
};
</script>


<style lang="scss">
#start {
  h1 {
    font-size: 2rem;
    font-weight: bold;
    max-width: 200px;
    margin: 0 auto;
    margin-bottom: -1rem;
    @media (min-width: 576px) {
      max-width: 380px;
    }
    @media (min-width: 768px) {
      font-size: 3rem;
      max-width: 50%;
      margin-bottom: -2rem;
    }
  }

  p {
    color: #000;
    font-weight: bold;
  }
  .btn-click {
    font-size: 1.5rem;
    line-height: 1.1;
    @media (min-width: 768px) {
      font-size: 2rem;
    }
  }
}

.pulse-button {
  box-shadow: 0 0 0 0 rgba(255, 255, 255, 0), 0 0 0 0 rgba(255, 255, 255, 0.7);
  transform: translate3d(0, 0, 0);
  animation: pulse 1.25s infinite cubic-bezier(0.66, 0.33, 0, 1);
  &:hover {
    animation-play-state: paused;
  }
}
@keyframes pulse {
  to {
    box-shadow: 0 0 0 12px transparent, 0 0 0 24px rgba(255, 255, 255, 0);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/start.vue